var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticon-component",style:(`
    fill: ${_vm.icon_color};
    width: ${_vm.icon_size}px;
    height: ${_vm.icon_size}px;
    ${ _vm.dropshadow ? 'filter: drop-shadow(1px 2px #0007);' : ''}
    ${ _vm.shadow ? `filter: drop-shadow(3px 3px 2px ${_vm.shadow_color});` : ''}
  `),domProps:{"innerHTML":_vm._s(_vm.getSVGIcon(_vm.name))}})
}
var staticRenderFns = []

export { render, staticRenderFns }